import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Denver needed",
      "Ideal for MSU students studying abroad",
      "Great for Yellowstone-area tourism professionals",
      "Perfect for Bozeman's growing tech & remote workforce",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Bozeman post offices",
      "Good for planned international trips from BZN",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Gallatin County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "Rural Montana mail routing through Billings adds 1–2 weeks",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Montana has zero passport agencies — closest is Denver (~600 mi, 9+ hr drive) or Seattle (~660 mi, 10+ hr drive)",
      "NPIC appointment required before traveling to Denver or Seattle",
      "Life-or-death emergencies only — bereavement or medical crisis documentation required",
      "Winter conditions on I-90 & mountain passes make driving dangerous Oct–April; Bozeman Pass closes regularly",
      "Expect to wait all day or return next day at the agency",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Bozeman"
      headingExtra="MT"
      introText="Bozeman travelers — Montana State University students heading abroad, Yellowstone-area tourism professionals, the growing tech and remote workforce, and Gallatin Valley residents who know the nearest passport agency is a full day's drive away — have several options for getting a passport fast. Here is how they compare, and why most choose a U.S. Department of State registered passport courier for predictable processing without the 9+ hour drive to Denver."
      options={options}
      emergencyDescription="Montana has zero passport agencies. The closest are Denver (~600 miles, 9+ hour drive via I-90/I-25 through Wyoming) or Seattle (~660 miles, 10+ hours via I-90). Winter conditions on mountain passes make driving dangerous from October through April, and Bozeman Pass on I-90 closes regularly during heavy snow. Airline connections from BZN add $300+. You must obtain an NPIC appointment before traveling — walk-ins are not accepted at either location."
      disclaimerText="*Processing speed depends on eligibility and documentation. Montana has no regional passport agency — the closest are Denver and Seattle. Not all applicants qualify for Regional Agency Processing."
    />
  );
}